/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Card, CardBody, Col, Collapse } from 'reactstrap';
import type { ColumnProps } from 'reactstrap/types/lib/Col';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import classNames from 'classnames';

interface Props {
  md?: ColumnProps;
  title?: string;
  className?: string;
  onlyDesktop?: boolean;
  onlyMobile?: boolean;
  children?: React.ReactNode;
}

const SectionCollapsable: React.FC<Props> = ({
  md = 12,
  title,
  className,
  children,
  onlyDesktop,
  onlyMobile,
}) => {
  const [state, setState] = useState({
    collapse: false,
    status: 'closed',
  });

  const classes = classNames({ 'only-desktop': onlyDesktop, 'only-mobile': onlyMobile });

  const onEntering = () => {
    setState({ ...state, status: 'opening' });
  };

  const onEntered = () => {
    setState({ ...state, status: 'opened' });
  };

  const onExiting = () => {
    setState({ ...state, status: 'closing' });
  };

  const onExited = () => {
    setState({ ...state, status: 'closed' });
  };

  const toggle = () => {
    setState((prev) => ({ ...state, collapse: !prev.collapse }));
  };
  return (
    <Col md={md} className={classes}>
      <Card>
        <CardBody className={className}>
          {title && (
            <div className={`collapse__wrapper with-shadow ${state.status} ${className || ''}`}>
              <button onClick={toggle} className="collapse__title custom" type="button">
                <p>
                  {title}
                  <ChevronDownIcon />
                </p>
              </button>
              <Collapse
                isOpen={state.collapse}
                className="collapse__content"
                onEntering={onEntering}
                onEntered={onEntered}
                onExiting={onExiting}
                onExited={onExited}
              >
                <div>{children}</div>
              </Collapse>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default SectionCollapsable;
